//* Components
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'

//* Style
import EmptyStyle from './style'

const Empty = ({ hasSubtitle }) => {
	return (
		<EmptyStyle>
			<Icon name='sad-smily' className='no-result-icon secondaryColor2' />
			<Text className='font-ping-bolder h5 no-result-title' text='noResultTitle' />
			{hasSubtitle && <Text className='secondaryColor2 p' text='noResultSubtitle' />}
		</EmptyStyle>
	)
}

Empty.defaultProps = {
	hasSubtitle: true,
}

export default Empty
